import { jwtDecode } from "jwt-decode";
import { User } from "../models/auth.models";
import { secrets } from "./secrets";
import { AES, enc } from 'crypto-js';
import * as crypto from 'crypto-js';
import { Select2Data } from "ng-select2-component";


/**
 * @returns registered user list
 */
function getAllUsers(): User[] {
  // array in session storage for registered users
  let users: User[] = JSON.parse(sessionStorage.getItem('users')!) || [
    {
      id: 1, username: 'test', email: 'adminto@coderthemes.com', password: 'test', firstName: 'Nowak', lastName: 'Helme',
      avatar: 'assets/images/users/user-1.jpg', location: 'California, USA', title: 'Admin Head'
    }
  ];
  return users;
}


/**
 * Returns the current user
 */
function loggedInUser(): User | null {
  let user: User | null = {};

  if (sessionStorage.getItem('currentUser')) {
    let token = decodeToken(sessionStorage.getItem('currentUser')!);
    let jwttoken: any = jwtDecode(token) // Le pongo tipo any para que me permita acceder a jwtoken.id
    // Los datos del usuario los saco en auth.model.ts porque es donde tengo acceso al servicio de usuarios
    user = {
      "id": jwttoken.id,
    }
    return user;
  }
  else {
    return null;
  }



}

/**
 * Encode Token with secret
 */
function encodeToken(token: string) {
  let tokenEncrypted = crypto.AES.encrypt(token, secrets.salt);
  var plaintextToken = tokenEncrypted.toString();
  return plaintextToken;
}



/**
 * Decode Token with secret
 */
function decodeToken(token: string) {
  if (token) {
    let tokenDecrypted = crypto.AES.decrypt(token.toString(), secrets.salt);
    var plaintextToken = tokenDecrypted.toString(crypto.enc.Utf8);
    return plaintextToken;
  } else {
    return '' // Token nulo
  }

}

// -----------------------------------
// Convertir códigos de nacionalidad
// -----------------------------------
function convertNacionalidadesToLabels(codigos: string[], nacionalidades: Select2Data): string {
  return codigos.map(codigo => {
    const match = nacionalidades.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join(', '); // Une las etiquetas con coma si hay más de una
}


// -----------------------------------
// Convertir códigos de idiomas
// -----------------------------------
function convertIdiomasToLabels(codigos: string[], idiomas: Select2Data): string {
  return codigos.map(codigo => {
    const match = idiomas.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join(', '); // Une las etiquetas con coma si hay más de una
}

// -----------------------------------
// Convertir códigos de profesiones 
// -----------------------------------
function convertProfesionesToLabels(codigos: string[], profesiones: Select2Data): string {
  return codigos.map(codigo => {
    const match = profesiones.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join(', '); // Une las etiquetas con coma si hay más de una
}

// -----------------------------------
// Convertir códigos de colegiaciones 
// -----------------------------------
function convertColegiacionesToLabels(codigos: string[], colegiaciones: Select2Data): string {
  return codigos.map(codigo => {
    const match = colegiaciones.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join(', '); // Une las etiquetas con coma si hay más de una
}

// -----------------------------------
// Convertir códigos de sectores 
// -----------------------------------
function convertSectoresToLabels(codigos: string[], sectores: Select2Data): string {
  return codigos.map(codigo => {
    const match = sectores.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join('\n'); // Une las etiquetas con coma si hay más de una
}

// -----------------------------------
// Convertir códigos de sistemas Jurídicos 
// -----------------------------------
function convertsistemasJuridicosToLabels(codigos: string[], sistemasJuridicos: Select2Data): string {
  return codigos.map(codigo => {
    const match = sistemasJuridicos.find(nac => 'value' in nac && nac.value === codigo);
    return match ? match.label : codigo; // Retorna la etiqueta si se encuentra, de lo contrario retorna el código
  }).join('\n'); // Une las etiquetas con coma si hay más de una
}

// -----------------------------------
// Obtener el idioma en base a la carpeta
// -----------------------------------
function getCurrentLanguage() {
  // Este enfoque funciona en cualquier parte del frontend que pueda acceder a window.location
  const path = window.location.pathname; // Obtiene la ruta actual del navegador
  const segments = path.split('/'); // Divide la ruta en segmentos

  // Verifica si el segmento de idioma está presente y es 'en', de lo contrario, devuelve 'es'
  // Puedes agregar más casos o modificar estos según tus necesidades

  return segments.includes('en') ? 'en' : 'es';
  //TEST simulo estar en la carpeta EN
  //return "en";
}

// -----------------------------------
// Formatea la fecha obtenida de la base de datos a un formato legible teniendo en cuenta los idiomas
// -----------------------------------
function formatDateString(dateString: string, language: string): string {
  // Verificar si dateString es válido
  if (!dateString) {
    return "Fecha no válida"; // Retorna un mensaje por defecto si la fecha es vacía
  }

  // Crear la fecha desde la cadena ISO sin ajustes de zona horaria
  const [datePart, timePart] = dateString.split('T');
  if (!datePart || !timePart) {
    return ""; // Manejar casos en los que el formato de dateString no sea el esperado
  }

  const [year, month, day] = datePart.split('-');
  const [hour, minute] = timePart.split(':');

  if (!year || !month || !day || !hour || !minute) {
    return ""; // Verificar que todos los componentes de la fecha estén presentes
  }

  const shortYear = year.slice(-2);

  // Crear una fecha formateada manualmente
  let formattedDate: string;

  switch (language) {
    case 'es':
      // Español: formato dd-mm-yyyy
      formattedDate = `${day}/${month}/${shortYear}`;
      break;
    case 'en':
      // Inglés: formato dd-mm-yyyy
      formattedDate = `${shortYear}/${month}/${day}`; // o 'en-GB' si prefieres dd/mm/yyyy
      break;
    default:
      // Retorna la fecha en el formato ISO 8601 si el idioma no es soportado
      return dateString;
  }

  // Concatenar fecha y hora exacta, sin transformaciones de zona horaria
  const formattedTime = `${hour}:${minute}`;

  return `${formattedDate}`;
}


// -----------------------------------
// Formatea la fecha obtenida de la base de datos a un formato legible teniendo en cuenta los idiomas y con la hora
// -----------------------------------
function formatDateStringWithTime(dateString: string, language: string): string {
  // Verificar si dateString es válido
  if (!dateString) {
    return ""; // Retorna un mensaje por defecto si la fecha es vacía
  }

  // Crear la fecha desde la cadena ISO sin ajustes de zona horaria
  const [datePart, timePart] = dateString.split('T');
  if (!datePart || !timePart) {
    return ""; // Manejar casos en los que el formato de dateString no sea el esperado
  }

  const [year, month, day] = datePart.split('-');
  const [hour, minute] = timePart.split(':');

  if (!year || !month || !day || !hour || !minute) {
    return ""; // Verificar que todos los componentes de la fecha estén presentes
  }

  const shortYear = year.slice(-2);

  // Crear una fecha formateada manualmente
  let formattedDate: string;

  switch (language) {
    case 'es':
      // Español: formato dd-mm-yyyy
      formattedDate = `${day}/${month}/${shortYear}`;
      break;
    case 'en':
      // Inglés: formato dd-mm-yyyy
      formattedDate = `${day}/${month}/${shortYear}`; // o 'en-GB' si prefieres dd/mm/yyyy
      break;
    default:
      // Retorna la fecha en el formato ISO 8601 si el idioma no es soportado
      return dateString;
  }

  // Concatenar fecha y hora exacta, sin transformaciones de zona horaria
  const formattedTime = `${hour}:${minute}`;

  return `${formattedDate} ${formattedTime}`;
}




export {
  getAllUsers, loggedInUser, encodeToken, decodeToken, convertNacionalidadesToLabels, convertIdiomasToLabels, convertProfesionesToLabels, convertColegiacionesToLabels,
  convertSectoresToLabels, convertsistemasJuridicosToLabels, getCurrentLanguage, formatDateString, formatDateStringWithTime
}

